import React from 'react';
import { Alert as AntdAlert, AlertProps as AntdAlertProps } from 'antd';
import cn from 'classnames';

import type { StatusColor } from 'admin/components/common/Tag';
import css from './Alert.scss';

type Props = Omit<AntdAlertProps, 'message'> & {
	children?: React.ReactNode;
	color?: StatusColor;
	message?: React.ReactNode;
};

const Alert = ({ className, children, color = 'success', message, ...props }: Props) => {
	return (
		<AntdAlert
			className={cn(css.alert, css[color], className)}
			{...props}
			title={children ?? props.title ?? message}
		/>
	);
};

export default Alert;
